<template>

    <div class="container">

        <back :href="route('admin.suppliers.index')" />

        <h1 class="page-heading">
            {{ supplier.short_name }} {{ __('Categories') }}
        </h1>

        <div class="mb-4">
            {{ __('Mapping von Lieferanten-Kategorien auf interne Kategorien') }}
        </div>

        <div class="card">
            <div class="card-body">

                <div class="text-muted" v-if="supplierCategoryTree.length === 0">
                    {{ __('Keine Kategorien') }}
                </div>
                <div class="" v-else>
                    <div class="py-2 border-bottom">
                        <div class="row fw-bold">
                            <div class="col-sm-4">{{ __('Supplier Category') }}</div>
                            <div class="col-sm-1">{{ __('UID') }}</div>
                            <div class="col-sm-1">{{ __('Products') }}</div>
                            <div class="col-sm-6">{{ __('Mapped Categories') }}</div>
                        </div>
                    </div>
                    <category-nodes v-for="supplierCategory in supplierCategoryTree" 
                                    :key="supplierCategory.id" 
                                    :depth="0"
                                    :supplier="supplier"
                                    :supplier-category="supplierCategory"
                                    :current-supplier-category="currentSupplierCategory"
                                    :category-tree="categoryTree"
                                    :supplier-category-tree="supplierCategoryTree"
                                    :supplier-categories-flat="supplierCategoriesFlat"
                                    />
                </div>


            </div>
        </div>

    </div>

</template>

<script>

    import CategoryNodes from './CategoryNodes';

    export default {
        props: [
            'filters',
            'supplier',
            'categoryTree',
            'supplierCategoryTree',
            'supplierCategoriesFlat',
            'currentSupplierCategory',
        ],
        components: {
            CategoryNodes,
        },
        data() {
            return {

            }
        },
        watch: {
        },
        methods: {
        },
    }
</script>
